const hubspotProfile = {
    selectors: [],
    indicators: ['[data-selenium-test="company-chicklet-title-link"]'],
};
const hubspotCompany = {
    selectors: [],
    indicators: ['[data-selenium-test="company-highlight-details"]'],
};
const HUBSPOT_LISTENERS_INDICATORS_BY_CONTEXT_TYPE = {
    profile: hubspotProfile,
    company: hubspotCompany,
    unknown: {
        selectors: [],
        indicators: [...hubspotProfile.indicators, ...hubspotCompany.indicators],
    },
};
export const getHubspotPageListeners = context => HUBSPOT_LISTENERS_INDICATORS_BY_CONTEXT_TYPE[context];
